export const LOGIN_PATH = "/login"
export const PANEL_BASE_PATH = "/"
export const REQUESTS_PATH = "/requests"
export const REQUEST_NEW_PATH = "/requests/new"
export const REQUEST_EDIT_PATH = "/requests/:id/edit"
export const REQUEST_VIEW_PATH = "/requests/:id"
// The facility member list of a request, once a facility is granted.
export const REQUEST_MEMBERS_PATH = "/requests/:id/members"
export const requestMembersPath = (groupId: string) => `/requests/${groupId}/members`
